import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import {ArticlePage} from '../../../../core/content/types/article.types'
import {EMPTY, Observable} from 'rxjs'
import {ResolverUtilService} from '../../../../core/resolver/resolver-util.service'
import {catchError, tap} from 'rxjs/operators'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'
import {LinkService} from '../../../../core/i18n/link.service'
import {ArticleContentService} from '../../../../core/content/services/article-content.service'
import {TranslocoService} from '@ngneat/transloco'
import {Language} from '../../../../core/i18n/language'

@Injectable()
export class ArticleResolver {
  constructor(
    private readonly contentService: ArticleContentService,
    private readonly linkService: LinkService,
    private readonly util: ResolverUtilService,
    private readonly localeService: TranslocoService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ArticlePage> {
    const slug = route.paramMap.get('pageSlug')
    if (!slug) {
      return this.util.redirectToNotFound(state.url)
    }
    return this.contentService.getArticlePage(slug).pipe(
      tap(article => {
        const currentLocale = this.localeService.getActiveLang() as Language
        if (!article.activeLocales.includes(currentLocale)) {
          this.redirectToArticleUnavailable(slug)
        }
      }),
      catchError(e => this.util.handleError(e, state.url)),
    )
  }

  private redirectToArticleUnavailable(slug: string): Observable<never> {
    this.linkService.navigateTo(PUBLIC_ROUTES.ARTICLE_PAGE_UNAVAILABLE, {routeParams: {pageSlug: slug}})
    return EMPTY
  }
}
